/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Webplatform-ts V2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DataModelWireDetails,
  DeleteV2WireDetailsBatchBodyItem,
  DeleteV2WireDetailsBatchParams,
  GetV2WireDetailsParams,
  GetV2WireDetailsReceiver200,
  HandlersPostWireDetailsBatchItem,
  HandlersPutWireDetailsBatchItem
} from '../../model';

import { webplatformProxyInstance } from '../../../../../lib/integrations/axios.ts';
import type { ErrorType } from '../../../../../lib/integrations/axios.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * This endpoint will return a list of wire details based on the filter provided
 * @summary An endpoint to request many wire details
 */
export const getV2WireDetails = (
    params?: GetV2WireDetailsParams,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<DataModelWireDetails[]>(
      {url: `/v2/wire-details`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetV2WireDetailsQueryKey = (params?: GetV2WireDetailsParams,) => {
    return [
    `/v2/wire-details`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetV2WireDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getV2WireDetails>>, TError = ErrorType<unknown>>(params?: GetV2WireDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2WireDetails>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV2WireDetailsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2WireDetails>>> = ({ signal }) => getV2WireDetails(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV2WireDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV2WireDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getV2WireDetails>>>
export type GetV2WireDetailsQueryError = ErrorType<unknown>


export function useGetV2WireDetails<TData = Awaited<ReturnType<typeof getV2WireDetails>>, TError = ErrorType<unknown>>(
 params: undefined |  GetV2WireDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2WireDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2WireDetails>>,
          TError,
          Awaited<ReturnType<typeof getV2WireDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2WireDetails<TData = Awaited<ReturnType<typeof getV2WireDetails>>, TError = ErrorType<unknown>>(
 params?: GetV2WireDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2WireDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2WireDetails>>,
          TError,
          Awaited<ReturnType<typeof getV2WireDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2WireDetails<TData = Awaited<ReturnType<typeof getV2WireDetails>>, TError = ErrorType<unknown>>(
 params?: GetV2WireDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2WireDetails>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary An endpoint to request many wire details
 */

export function useGetV2WireDetails<TData = Awaited<ReturnType<typeof getV2WireDetails>>, TError = ErrorType<unknown>>(
 params?: GetV2WireDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2WireDetails>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV2WireDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns Agora's bank account information for receiving wire transfers
 * @summary Get Agora's bank account details for wire transfers
 */
export const getV2WireDetailsReceiver = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV2WireDetailsReceiver200>(
      {url: `/v2/wire-details/receiver`, method: 'GET', signal
    },
      options);
    }




export const getGetV2WireDetailsReceiverQueryKey = () => {
    return [
    `/v2/wire-details/receiver`
    ] as const;
    }


export const getGetV2WireDetailsReceiverQueryOptions = <TData = Awaited<ReturnType<typeof getV2WireDetailsReceiver>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2WireDetailsReceiver>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV2WireDetailsReceiverQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2WireDetailsReceiver>>> = ({ signal }) => getV2WireDetailsReceiver(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV2WireDetailsReceiver>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV2WireDetailsReceiverQueryResult = NonNullable<Awaited<ReturnType<typeof getV2WireDetailsReceiver>>>
export type GetV2WireDetailsReceiverQueryError = ErrorType<unknown>


export function useGetV2WireDetailsReceiver<TData = Awaited<ReturnType<typeof getV2WireDetailsReceiver>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2WireDetailsReceiver>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2WireDetailsReceiver>>,
          TError,
          Awaited<ReturnType<typeof getV2WireDetailsReceiver>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2WireDetailsReceiver<TData = Awaited<ReturnType<typeof getV2WireDetailsReceiver>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2WireDetailsReceiver>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2WireDetailsReceiver>>,
          TError,
          Awaited<ReturnType<typeof getV2WireDetailsReceiver>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2WireDetailsReceiver<TData = Awaited<ReturnType<typeof getV2WireDetailsReceiver>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2WireDetailsReceiver>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Agora's bank account details for wire transfers
 */

export function useGetV2WireDetailsReceiver<TData = Awaited<ReturnType<typeof getV2WireDetailsReceiver>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2WireDetailsReceiver>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV2WireDetailsReceiverQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Create new wire details and return a list of newly created wire details
 * @summary Create new wire details in a batch
 */
export const postV2WireDetailsBatch = (
    handlersPostWireDetailsBatchItem: HandlersPostWireDetailsBatchItem[],
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<DataModelWireDetails[]>(
      {url: `/v2/wire-details/batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersPostWireDetailsBatchItem, signal
    },
      options);
    }




export const getPostV2WireDetailsBatchMutationKey = () => ['postV2WireDetailsBatch'] as const;

export const getPostV2WireDetailsBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV2WireDetailsBatch>>, TError,PostV2WireDetailsBatchMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postV2WireDetailsBatch>>, TError,PostV2WireDetailsBatchMutationVariables, TContext> => {

const mutationKey = getPostV2WireDetailsBatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postV2WireDetailsBatch>>, PostV2WireDetailsBatchMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postV2WireDetailsBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostV2WireDetailsBatchMutationResult = NonNullable<Awaited<ReturnType<typeof postV2WireDetailsBatch>>>
    export type PostV2WireDetailsBatchMutationBody = HandlersPostWireDetailsBatchItem[]
    export type PostV2WireDetailsBatchMutationError = ErrorType<unknown>
    export type PostV2WireDetailsBatchMutationVariables = {data: HandlersPostWireDetailsBatchItem[]}

    /**
 * @summary Create new wire details in a batch
 */
export const usePostV2WireDetailsBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV2WireDetailsBatch>>, TError,PostV2WireDetailsBatchMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postV2WireDetailsBatch>>,
        TError,
        PostV2WireDetailsBatchMutationVariables,
        TContext
      > => {
      return useMutation(getPostV2WireDetailsBatchMutationOptions(options), queryClient);
    }
    /**
 * This endpoint will update many wire details based on the primary key provided
 * @summary An endpoint to update many wire details in a batch
 */
export const putV2WireDetailsBatch = (
    handlersPutWireDetailsBatchItem: HandlersPutWireDetailsBatchItem[],
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<DataModelWireDetails[]>(
      {url: `/v2/wire-details/batch`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: handlersPutWireDetailsBatchItem, signal
    },
      options);
    }




export const getPutV2WireDetailsBatchMutationKey = () => ['putV2WireDetailsBatch'] as const;

export const getPutV2WireDetailsBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2WireDetailsBatch>>, TError,PutV2WireDetailsBatchMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putV2WireDetailsBatch>>, TError,PutV2WireDetailsBatchMutationVariables, TContext> => {

const mutationKey = getPutV2WireDetailsBatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putV2WireDetailsBatch>>, PutV2WireDetailsBatchMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putV2WireDetailsBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutV2WireDetailsBatchMutationResult = NonNullable<Awaited<ReturnType<typeof putV2WireDetailsBatch>>>
    export type PutV2WireDetailsBatchMutationBody = HandlersPutWireDetailsBatchItem[]
    export type PutV2WireDetailsBatchMutationError = ErrorType<unknown>
    export type PutV2WireDetailsBatchMutationVariables = {data: HandlersPutWireDetailsBatchItem[]}

    /**
 * @summary An endpoint to update many wire details in a batch
 */
export const usePutV2WireDetailsBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2WireDetailsBatch>>, TError,PutV2WireDetailsBatchMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putV2WireDetailsBatch>>,
        TError,
        PutV2WireDetailsBatchMutationVariables,
        TContext
      > => {
      return useMutation(getPutV2WireDetailsBatchMutationOptions(options), queryClient);
    }
    /**
 * This endpoint will delete many wire details based on the primary key provided
 * @summary An endpoint to delete many wire details in a batch
 */
export const deleteV2WireDetailsBatch = (
    deleteV2WireDetailsBatchBodyItem: DeleteV2WireDetailsBatchBodyItem[],
    params?: DeleteV2WireDetailsBatchParams,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<DataModelWireDetails[]>(
      {url: `/v2/wire-details/batch`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteV2WireDetailsBatchBodyItem,
        params, signal
    },
      options);
    }




export const getDeleteV2WireDetailsBatchMutationKey = () => ['deleteV2WireDetailsBatch'] as const;

export const getDeleteV2WireDetailsBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteV2WireDetailsBatch>>, TError,DeleteV2WireDetailsBatchMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteV2WireDetailsBatch>>, TError,DeleteV2WireDetailsBatchMutationVariables, TContext> => {

const mutationKey = getDeleteV2WireDetailsBatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteV2WireDetailsBatch>>, DeleteV2WireDetailsBatchMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  deleteV2WireDetailsBatch(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteV2WireDetailsBatchMutationResult = NonNullable<Awaited<ReturnType<typeof deleteV2WireDetailsBatch>>>
    export type DeleteV2WireDetailsBatchMutationBody = DeleteV2WireDetailsBatchBodyItem[]
    export type DeleteV2WireDetailsBatchMutationError = ErrorType<unknown>
    export type DeleteV2WireDetailsBatchMutationVariables = {data: DeleteV2WireDetailsBatchBodyItem[];params?: DeleteV2WireDetailsBatchParams}

    /**
 * @summary An endpoint to delete many wire details in a batch
 */
export const useDeleteV2WireDetailsBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteV2WireDetailsBatch>>, TError,DeleteV2WireDetailsBatchMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteV2WireDetailsBatch>>,
        TError,
        DeleteV2WireDetailsBatchMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteV2WireDetailsBatchMutationOptions(options), queryClient);
    }
